const g = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNDIyIDJMMjIgNS42NzdWMjBhMiAyIDAgMCAxLTIgMkg0YTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDE0LjQyMnpNNyA0SDR2MTZoMnYtOGgxMnY4aDJWNi40OUwxNy41NzggNEgxN3Y2SDdWNHptOSAxMEg4djZoOHYtNnpNMTUgNEg5djRoNlY0em0tMSAxdjJoLTJWNWgyeiIgIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export {
  g as default
};
//# sourceMappingURL=save-a77129a0.mjs.map
